import React from "react";
import PropTypes from "prop-types";

import PaymentNotice from "../PaymentNotice";

/** "Upgrade requires approval" notice shared by the upgrade and payment popups. */
const UpgradeApprovalNotice = ({ t }) => (
  <PaymentNotice
    title={t.approvalNoticeTitle}
    description={t.approvalNoticeMessage}
  />
);

UpgradeApprovalNotice.propTypes = {
  /** `events.viewEvents.crewSizeUpgrade` copy. */
  t: PropTypes.object.isRequired,
};

export default UpgradeApprovalNotice;
